import React from "react";

interface Props {
  file: server.dto.File
}

const FileTag = ({ file }: Props) => {
  const fileName = file.name.length > 25
    ? file.name.substr(0, 21) + "… " + "." + file.extension
    : file.fullName;

  return <a className="ui label" title={file.fullName} download href={file.downloadUrl}>
    {fileName}
  </a>;
};

export default FileTag;
